import { Component, OnInit } from '@angular/core';
import * as alertifyjs from 'alertifyjs';
import { UserService } from 'src/app/services/user/user.service';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-code-type-product',
  templateUrl: './code-type-product.component.html',
  styleUrls: ['./code-type-product.component.css']
})
export class CodeTypeProductComponent implements OnInit {

  // Navigation state management
  currentView: 'main' | 'detail' = 'main';
  selectedProductType: any = null;

  // View mode management (similar to plans)
  viewMode: 'list' | 'cards' = 'list'; // Default to list as requested

  codesList:any[] = [];
  isModalOpen:boolean = false;
  isModalOpenProducts:boolean = false;
  newCode:any = {code: '', name: '', description: ''};
  newProduct:any = {type: '', name: '', description: ''};
  formEmpty:any;
  errorType:boolean = false;
  errorName:boolean = false;
  globalError:boolean = false;

  productArray:any[] = [];
  productSelected:any;
  filterButtonProduct:boolean = false;
  messageSelect:string = "0";
  openProducts:boolean = false;
  itemProduct:any[] = [];

  // New properties for dynamic codes functionality
  isModalDynamicCodesOpen: boolean = false;
  dynamicCodesForProduct: any[] = [];
  availableDynamicCodes: any[] = [];
  selectedProductForDynamic: string = '';
  selectedDynamicCode: string = '';
  errorProductDynamic: boolean = false;
  errorDynamicCode: boolean = false;
  allDynamicCodes: any[] = [];

  // New properties for enhanced modal functionality
  searchDynamicCode: string = '';
  showDropdown: boolean = false;
  filteredAvailableCodes: any[] = [];

  // New properties for remanente-neteo functionality
  isModalRemanenteNeteoOpen: boolean = false;
  remainingNeteoConfigs: any[] = [];
  selectedProductForRemanenteNeteo: string = '';
  remanenteNeteoForm: any = {
    product_code: '',
    domiciliacion: {
      status: false,
      allowed_banks: [],
      allowed_types: [],
      retry_limit_enabled: false,
      retry_limit_days: null,
      exclude_weekends: false,
      staggered_collection: false,
      direct_reference_payment: false
    },
    fees: {
      status: false
    },
    remanente: {
      status: false,
      amount: 0
    },
    neteo: {
      status: false,
      amount: 0
    },
    // New insurance configuration properties
    insurance: {
      is_insurance_product: false,
      insurer_code: ''
    },
    display_order: 0
  };
  errorProductRemanenteNeteo: boolean = false;
  errorRemanenteAmount: boolean = false;
  errorNeteoAmount: boolean = false;
  errorExternalRateChannel: boolean = false;
  errorRetryLimitDays: boolean = false;
  isLoading: boolean = false;

  // New properties for insurance configuration
  insurers: any[] = [];
  insuranceConfigForm: any = {
    product_code: '',
    is_insurance_product: false,
    insurer_code: ''
  };
  errorInsuranceInsurer: boolean = false;

  // Banks and types for domiciliation per product
  banksList: any[] = [];
  selectedAllowedBanks: string[] = [];
  domiciliationTypes: any[] = [
    { id: 1, name: 'Cuotas - Diario' },
    { id: 2, name: 'Cuotas - Masivo' },
    { id: 3, name: 'Cuotas - Morosos' },
    { id: 4, name: 'Penalidades' },
  ];
  selectedAllowedTypes: number[] = [];
  bankToAdd: string = '';
  typeToAdd: number | null = null;

  // 🆕 T&C DE DOMICILIACIÓN POR PRODUCTO Y BANCO
  isModalTermsConditionsOpen: boolean = false;
  selectedBankForTerms: string = '';
  termsConditionsForm: any = {
    product_type: '',
    bank_code: '',
    name: '',
    details: ''
  };
  currentTermsVersion: any = null;
  termsHistory: any[] = [];
  showTermsHistory: boolean = false;
  errorTermsName: boolean = false;
  errorTermsDetails: boolean = false;
  isLoadingTerms: boolean = false;
  isEditingTerms: boolean = false;
  banksWithTermsConfigured: Set<string> = new Set(); // Bancos que tienen T&C configurados
  showPreview: boolean = false; // Mostrar vista previa en el modal

  // Configuración del editor Quill
  quillModules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      ['blockquote', 'code-block'],
      [{ 'header': 1 }, { 'header': 2 }],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'script': 'sub'}, { 'script': 'super' }],
      [{ 'indent': '-1'}, { 'indent': '+1' }],
      [{ 'size': ['small', false, 'large', 'huge'] }],
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'align': [] }],
      ['clean'],
      ['link']
    ]
  };

  editorStyle = {
    height: '400px'
  };

  constructor(
        private _user: UserService,
        public _auth: AuthService,
  ) { }

  ngOnInit(): void {
    this.consultAllCodes();
    this.consultAllProductsInvoices();
    this.loadDynamicCodes();
    this.loadRemanenteNeteoConfigs();
    this.loadInsurers();
    this.loadBanksList();
  }

  // Load banks available for domiciliación configuration (console banks)
  async loadBanksList() {
    try {
      const resp = await this._user.getBanksWithDirectDebitEnabled({});
      this.banksList = resp?.res || resp?.resp || [];
    } catch (error) {
      console.error('Error loading banks list:', error);
      this.banksList = [];
    }
  }

  // Helpers for mass selection in DOMICILIACIÓN UI
  selectAllBanks() {
    this.selectedAllowedBanks = (this.banksList || []).map((b: any) => b.code);
  }

  clearAllBanks() {
    this.selectedAllowedBanks = [];
  }

  selectAllTypes() {
    this.selectedAllowedTypes = (this.domiciliationTypes || []).map((t: any) => t.id);
  }

  clearAllTypes() {
    this.selectedAllowedTypes = [];
  }

  // Options remaining to add (filters)
  get bankOptionsToAdd() {
    const selected = new Set(this.selectedAllowedBanks);
    return (this.banksList || []).filter((b: any) => !selected.has(b.code));
  }

  get typeOptionsToAdd() {
    const selected = new Set(this.selectedAllowedTypes);
    return (this.domiciliationTypes || []).filter((t: any) => !selected.has(t.id));
  }

  // Add/remove single items
  addBank()
  {
    if (this.bankToAdd && !this.selectedAllowedBanks.includes(this.bankToAdd)) {
      this.selectedAllowedBanks = [...this.selectedAllowedBanks, this.bankToAdd];
    }
    this.bankToAdd = '';
  }

  removeBank(code: string)
  {
    this.selectedAllowedBanks = this.selectedAllowedBanks.filter(c => c !== code);
  }

  addType()
  {
    if (this.typeToAdd != null && !this.selectedAllowedTypes.includes(this.typeToAdd)) {
      this.selectedAllowedTypes = [...this.selectedAllowedTypes, this.typeToAdd];
    }
    this.typeToAdd = null;
  }

  removeType(id: number)
  {
    this.selectedAllowedTypes = this.selectedAllowedTypes.filter(t => t !== id);
  }

  // Template helpers (avoid arrow/functions inside template bindings)
  bankNameByCode(code: string): string {
    const b = (this.banksList || []).find((x: any) => x.code === code);
    return b?.name || code;
  }

  typeNameById(id: number): string {
    const t = (this.domiciliationTypes || []).find((x: any) => x.id === id);
    return t?.name || String(id);
  }

  // Navigation methods
  selectProductType(productType: any) {
    this.selectedProductType = productType;
    this.currentView = 'detail';
    
    console.log('🔍 [selectProductType] Producto seleccionado:', productType);
    console.log('🔍 [selectProductType] Código del producto:', productType.params?.code || productType.code);
    
    // Auto-filter all sections for the selected product type
    this.autoFilterSectionsForProduct(productType.params.code);
    
    // Cargar bancos con T&C configurados
    this.loadBanksWithTermsConfigured();
  }

  goBackToMain() {
    this.currentView = 'main';
    this.selectedProductType = null;
    
    // Reset all filters
    this.resetAllFilters();
  }

  private async autoFilterSectionsForProduct(productCode: string) {
    try {
      // Auto-select product for all sections
      this.productSelected = productCode;
      this.selectedProductForDynamic = productCode;
      this.selectedProductForRemanenteNeteo = productCode;
      this.remanenteNeteoForm.product_code = productCode;
      this.insuranceConfigForm.product_code = productCode;

      // Load data for CATEGORÍA section
      await this.loadCategoryData(productCode);
      
      // Load data for ETIQUETAS section
      await this.loadDynamicCodesData(productCode);
      
      // Load data for REMANENTE Y NETEO section
      await this.loadRemanenteNeteoData(productCode);
      
      // 🆕 Load data for T&C DE DOMICILIACIÓN section
      await this.loadTermsConditionsData(productCode);
      
    } catch (error) {
      console.error('Error auto-filtering sections:', error);
    }
  }

  /**
   * Cargar T&C activos para el producto seleccionado
   * Si no encuentra T&C para el producto específico, intenta con 'CREDIT' como fallback
   */
  private async loadTermsConditionsData(productCode: string) {
    try {
      // Intentar cargar T&C para el producto específico
      let response: any = await this._user.getActiveDomiciliationTerms(productCode);
      
      if (response?.success && response?.terms) {
        this.currentTermsVersion = response.terms;
        console.log(`✅ T&C cargados para producto: ${productCode}`);
        return;
      }

      // Si no encuentra y el producto no es 'CREDIT', intentar con 'CREDIT' como fallback
      if (productCode !== 'CREDIT') {
        console.log(`⚠️ No se encontraron T&C para ${productCode}, intentando con CREDIT...`);
        response = await this._user.getActiveDomiciliationTerms('CREDIT');
        
        if (response?.success && response?.terms) {
          this.currentTermsVersion = response.terms;
          console.log(`✅ T&C de CREDIT cargados como fallback para ${productCode}`);
          return;
        }
      }

      // No se encontraron T&C
      this.currentTermsVersion = null;
      console.log(`ℹ️ No hay T&C configurados para ${productCode}`);
      
    } catch (error) {
      console.error('Error loading T&C data:', error);
      this.currentTermsVersion = null;
    }
  }

  private async loadCategoryData(productCode: string) {
    try {
      let params = { code: productCode };
      let result = await this._user.getProductsInvoicesFilter(params);

      if (result.resp.length == 0) {
        this.itemProduct = [];
        return;
      }

      let resultProducts = result?.resp;
      let element;

      for (let i = 0; i < resultProducts.length; i++) {
        element = resultProducts[i];
      }

      this.itemProduct = element?.params?.products || [];
    } catch (error) {
      console.error('Error loading category data:', error);
      this.itemProduct = [];
    }
  }

  private async loadDynamicCodesData(productCode: string) {
    try {
      const response = await this._user.getDynamicCodesForProduct(productCode) as any;
      if (response && response.dinamic_codes) {
        this.dynamicCodesForProduct = response.dinamic_codes.map((code: string) => ({
          code: code,
          name: code,
          description: `Etiqueta: ${code}`
        }));
      } else {
        this.dynamicCodesForProduct = [];
      }
      this.updateAvailableDynamicCodes();
    } catch (error) {
      console.error('Error loading dynamic codes data:', error);
      this.dynamicCodesForProduct = [];
      alertifyjs.error('Error al cargar etiquetas');
    }
  }

  private async loadRemanenteNeteoData(productCode: string) {
    try {
      console.log('Cargando configuración para producto:', productCode);
      const response = await this._user.getRemanenteNeteo(productCode);
      console.log('Respuesta de configuración:', response);

      if (response) {
        this.remanenteNeteoForm.remanente = response.remanente || { status: false, amount: 0 };
        this.remanenteNeteoForm.neteo = response.neteo || { status: false, amount: 0 };
        // Load insurance configuration if available
        this.remanenteNeteoForm.insurance = response.insurance || { is_insurance_product: false, insurer_code: '' };
        console.log('Configuración de seguros cargada:', this.remanenteNeteoForm.insurance);
        // Load domiciliacion with proper defaults
        const domiciliacion = response.domiciliacion || {};
        this.remanenteNeteoForm.domiciliacion = {
          status: domiciliacion.status !== undefined ? domiciliacion.status : false,
          allowed_banks: domiciliacion.allowed_banks || [],
          allowed_types: domiciliacion.allowed_types || [],
          use_external_rate: domiciliacion.use_external_rate !== undefined ? domiciliacion.use_external_rate : false,
          external_rate_channel: domiciliacion.external_rate_channel || '',
          retry_limit_enabled: domiciliacion.retry_limit_enabled !== undefined ? domiciliacion.retry_limit_enabled : false,
          retry_limit_days: domiciliacion.retry_limit_days !== undefined ? domiciliacion.retry_limit_days : null,
          exclude_weekends: domiciliacion.exclude_weekends !== undefined ? domiciliacion.exclude_weekends : false,
          staggered_collection: domiciliacion.staggered_collection !== undefined ? domiciliacion.staggered_collection : false,
          direct_reference_payment: domiciliacion.direct_reference_payment !== undefined ? domiciliacion.direct_reference_payment : false
        };
        console.log('✅ Configuración de domiciliación cargada:', this.remanenteNeteoForm.domiciliacion);
        // Map allowed selections
        this.selectedAllowedBanks = this.remanenteNeteoForm?.domiciliacion?.allowed_banks || [];
        this.selectedAllowedTypes = this.remanenteNeteoForm?.domiciliacion?.allowed_types || [];
        this.remanenteNeteoForm.fees = response.fees || { status: false };
        this.remanenteNeteoForm.display_order = response.display_order !== undefined ? response.display_order : 0;
      } else {
        this.resetRemanenteNeteoFormData();
      }
    } catch (error: any) {
      if (error.status === 404) {
        console.log('No se encontró configuración existente para el producto:', productCode);
        this.resetRemanenteNeteoFormData();
      } else {
        console.error('Error loading remanente-neteo data:', error);
      }
    }
  }

  private resetAllFilters() {
    this.productSelected = null;
    this.selectedProductForDynamic = '';
    this.selectedProductForRemanenteNeteo = '';
    this.itemProduct = [];
    this.dynamicCodesForProduct = [];
    this.resetRemanenteNeteoFormData();
    // Reset insurance form
    this.insuranceConfigForm = {
      product_code: '',
      is_insurance_product: false,
      insurer_code: ''
    };
    this.errorInsuranceInsurer = false;
  }

  async serviceCode() {
    try {
      debugger;

      if (!this.newCode.code || !this.newCode.name) {
        this.globalError = true;
        return;
      }

      let params = {
        code: this.productSelected,
        code_product: this.newCode.code.trim(),
        name: this.newCode.name.trim(),
        description: this.newCode.description.trim()
      };

      let insertCodeProduct = await this._user.setProductsInvoices(params);


      if (insertCodeProduct) {
          alertifyjs.success(`Código del producto seleccionado agregado exitosamente`);
          this.toggleModal2();
          this.messageSelect = "0";
          this.filterButtonProduct = false;
          this.consultAllCodes();
        }

    } catch (error) {
      console.error('Error:', error);
      alertifyjs.error(`El código ya existe`);
    }
  }

  async productService() {
    try {
      debugger;

      this.errorType = this.newProduct.type.trim() === '';
      this.errorName = this.newProduct.name.trim() === '';

      if (this.errorType || this.errorName) {
        return;
      }


      let params = {
        type_product: this.newProduct.type.trim(),
        name: this.newProduct.name.trim(),
        description: this.newProduct.description.trim()
      };

      let insertProduct = await this._user.createProductsService(params);


      if (insertProduct) {
          alertifyjs.success(`Producto agregado exitosamente`);
          this.toogleModalProduct();
          this.consultAllProductsInvoices();
          this.resetFormProduct();
        }

    } catch (error) {
      console.error('Error:', error);
      alertifyjs.error(`El producto ya existe`);
    }
  }

 async consultAllCodes(){
    try {
      const response = await this._user.getAllCodesProduct();
      if (response && Array.isArray(response.res)) {
        this.codesList = response.res;
      } else {
        this.codesList = [];
      }
    } catch (error) {
      console.error('Error en los codigos:', error);
    }
  }

  async deleteProduct(code:string){
    try {
      debugger
      let params = {
        code_product: code
      }
      this._user.deleteProductComplete(params).then(response => {
        if(response){
          alertifyjs.success(`Código eliminado exitosamente`);
          this.productArray = this.productArray.filter(item => item.params.code !== code)
        }
      }).catch(error => {
        console.error('Error:', error);
        alertifyjs.error(`Error al eliminar el codigo`);
      });

    } catch (error) {
      throw error;
    }
  }

  async consultAllProductsInvoices(){
    try {

      debugger;

      let consultProducts = await this._user.getTypesProductsInvoices();

      this.productArray = consultProducts.resp;


    } catch (error) {
      throw error;
    }
  }

  async selectProductInvoice(event:Event) {
    debugger
    const target = event.target as HTMLSelectElement;
    const selectProductItem = target.value;

    this.productSelected = selectProductItem;

    let params = {
      code: this.productSelected
    }

    let result = await this._user.getProductsInvoicesFilter(params);

    if(result.resp.length == 0){
      this.itemProduct = [];
      return;
    }

    let resultProducts = result?.resp;
    let element;

    for (let i = 0; i < resultProducts.length; i++) {
      element = resultProducts[i];
    }

    this.itemProduct = element?.params?.products;
  }

  onCodeAdded() {
    this.consultAllCodes();
    
    // If we're in detail view, reload the category data for the selected product
    if (this.currentView === 'detail' && this.selectedProductType) {
      this.loadCategoryData(this.selectedProductType.params.code);
    }
  }

  toggleModal() {
    debugger;
    this.isModalOpen = !this.isModalOpen;
    this.consultAllProductsInvoices();
    this.resetForm();
  }

  toggleModal2() {
    this.isModalOpenProducts = !this.isModalOpenProducts;
    this.resetForm();
  }

  toogleModalProduct() {
    this.openProducts = !this.openProducts;
    this.resetForm();
  }

  resetForm(){
    this.newCode = {code: '', type: '', description: ''}
    this.globalError = false;
  }

  resetFormProduct(){
    this.newProduct = {type: '', name: '', description: ''};
    this.errorType = false;
    this.errorName = false;
  }

  // New methods for dynamic codes functionality
  toggleModalDynamicCodes() {
    this.isModalDynamicCodesOpen = !this.isModalDynamicCodesOpen;
    if (this.isModalDynamicCodesOpen) {
      this.loadDynamicCodes();
      
      // Auto-select product if we're in detail view
      if (this.currentView === 'detail' && this.selectedProductType) {
        console.log('Auto-selecting product in detail view:', this.selectedProductType.params.code);
        this.selectedProductForDynamic = this.selectedProductType.params.code;
        // Load dynamic codes for the selected product immediately
        this.loadDynamicCodesForSelectedProduct();
      } else {
        // Reset in main view
        this.selectedProductForDynamic = '';
      }
    }
    this.resetDynamicCodesForm();
  }

  async loadDynamicCodes() {
    try {
      // Load all dynamic codes - Real implementation using existing endpoint
      const response = await this._user.getAllCodes();
      if (response && response.data) {
        // Filter out only 'person' category codes, show all other categories that are active
        this.allDynamicCodes = response.data.filter((code: any) => 
          code.category !== 'person' && code.status === true
        );
        this.updateAvailableDynamicCodes();
      }
    } catch (error) {
      console.error('Error loading dynamic codes:', error);
      alertifyjs.error('Error al cargar etiquetas');
      this.allDynamicCodes = [];
    }
  }

  updateAvailableDynamicCodes() {
    if (!this.selectedProductForDynamic) {
      this.availableDynamicCodes = [...this.allDynamicCodes];
    } else {
      // Filter out codes that are already associated with the selected product
      const associatedCodes = this.dynamicCodesForProduct.map(code => code.code);
      this.availableDynamicCodes = this.allDynamicCodes.filter(code => 
        !associatedCodes.includes(code.code)
      );
    }
    
    // Initialize filtered codes
    this.filterAvailableCodes();
  }

  async selectProductForDynamicCodes(event: Event) {
    const target = event.target as HTMLSelectElement;
    const selectedProductCode = target.value;
    this.selectedProductForDynamic = selectedProductCode;

    if (selectedProductCode === '0' || !selectedProductCode) {
      this.dynamicCodesForProduct = [];
      this.updateAvailableDynamicCodes();
      return;
    }

    try {
      // Real implementation - Load dynamic codes associated with the selected product
      const response = await this._user.getDynamicCodesForProduct(selectedProductCode) as any;
      if (response && response.dinamic_codes) {
        // Convert backend structure to component structure
        this.dynamicCodesForProduct = response.dinamic_codes.map((code: string) => ({
          code: code,
          name: code,
          description: `Etiqueta: ${code}`
        }));
      } else {
        this.dynamicCodesForProduct = [];
      }
      this.updateAvailableDynamicCodes();
    } catch (error) {
      console.error('Error loading dynamic codes for product:', error);
      alertifyjs.error('Error al cargar etiquetas del producto');
      this.dynamicCodesForProduct = [];
    }
  }

  async associateDynamicCode() {
    try {
      console.log('=== DEBUG: associateDynamicCode ===');
      console.log('currentView:', this.currentView);
      console.log('selectedProductType:', this.selectedProductType);
      console.log('selectedProductForDynamic:', this.selectedProductForDynamic);
      console.log('selectedDynamicCode:', this.selectedDynamicCode);
      console.log('availableDynamicCodes:', this.availableDynamicCodes);
      
      this.errorProductDynamic = !this.selectedProductForDynamic;
      this.errorDynamicCode = !this.selectedDynamicCode;

      console.log('errorProductDynamic:', this.errorProductDynamic);
      console.log('errorDynamicCode:', this.errorDynamicCode);

      if (this.errorProductDynamic || this.errorDynamicCode) {
        console.log('Validation failed, returning early');
        alert('VALIDACIÓN FALLÓ: Producto=' + this.selectedProductForDynamic + ', Etiqueta=' + this.selectedDynamicCode);
        return;
      }

      // Real implementation - Call backend to associate dynamic code
      const body = {
        product_code: this.selectedProductForDynamic,
        dinamic_code: this.selectedDynamicCode  // Changed from dynamic_code to dinamic_code
      };

      console.log('Request body:', body);
      console.log('Calling backend...');

      const response = await this._user.associateDynamicCodeToProduct(body) as any;
      
      console.log('Backend response:', response);
      
      if (response && response.msg) {
        alertifyjs.success(response.msg || 'Etiqueta asociada exitosamente');
        this.toggleModalDynamicCodes();
        
        // Refresh the dynamic codes for the selected product
        await this.refreshDynamicCodesForProduct();
      } else {
        console.log('No response.msg, showing error');
        alertifyjs.error('Error al asociar la etiqueta');
      }
    } catch (error) {
      console.error('Error associating dynamic code:', error);
      alert('ERROR: ' + (error as any)?.message || JSON.stringify(error));
      if ((error as any).status === 404) {
        alertifyjs.error('Product invoice no encontrado');
      } else {
        alertifyjs.error('Error al asociar la etiqueta');
      }
    }
  }

  async removeDynamicCodeFromProduct(dynamicCode: string) {
    try {
      if (!this.selectedProductForDynamic) {
        alertifyjs.error('No hay producto seleccionado');
        return;
      }

      // Confirmation dialog
      const confirmed = await this.showConfirmationDialog(
        '¿Estás seguro?', 
        `¿Deseas eliminar la asociación de la etiqueta "${dynamicCode}" con el producto "${this.selectedProductForDynamic}"?`
      );

      if (!confirmed) {
        return;
      }

      // Real implementation - Call backend to remove association
      const body = {
        product_code: this.selectedProductForDynamic,
        dinamic_code: dynamicCode  // Changed from dynamic_code to dinamic_code
      };

      const response = await this._user.removeDynamicCodeFromProduct(body) as any;
      
      if (response && response.msg) {
        alertifyjs.success(response.msg || 'Etiqueta eliminada exitosamente');
        
        // Refresh the dynamic codes for the selected product
        await this.refreshDynamicCodesForProduct();
      } else {
        alertifyjs.error('Error al eliminar la etiqueta');
      }
    } catch (error) {
      console.error('Error removing dynamic code:', error);
      if ((error as any).status === 404) {
        alertifyjs.error('Product invoice no encontrado o etiqueta no existe');
      } else {
        alertifyjs.error('Error al eliminar la etiqueta');
      }
    }
  }

  // Helper method to refresh dynamic codes for selected product
  private async refreshDynamicCodesForProduct() {
    if (this.selectedProductForDynamic) {
      try {
        const response = await this._user.getDynamicCodesForProduct(this.selectedProductForDynamic) as any;
        if (response && response.dinamic_codes) {
          // Convert backend structure to component structure
          this.dynamicCodesForProduct = response.dinamic_codes.map((code: string) => ({
            code: code,
            name: code,
            description: `Etiqueta: ${code}`
          }));
        } else {
          this.dynamicCodesForProduct = [];
        }
        this.updateAvailableDynamicCodes();
      } catch (error) {
        console.error('Error refreshing dynamic codes:', error);
        this.dynamicCodesForProduct = [];
      }
    }
  }

  // Helper method for confirmation dialogs
  private showConfirmationDialog(title: string, message: string): Promise<boolean> {
    return new Promise((resolve) => {
      alertifyjs.confirm(title, message, 
        () => resolve(true),  // OK callback
        () => resolve(false)  // Cancel callback
      );
    });
  }

  resetDynamicCodesForm() {
    // Don't reset selectedProductForDynamic if we're in detail view
    if (this.currentView !== 'detail') {
      this.selectedProductForDynamic = '';
    }
    this.selectedDynamicCode = '';
    this.searchDynamicCode = '';
    this.showDropdown = false;
    this.errorProductDynamic = false;
    this.errorDynamicCode = false;
    // Don't reset dynamicCodesForProduct as it's loaded automatically
  }

  // Helper method to load dynamic codes for the currently selected product
  async loadDynamicCodesForSelectedProduct() {
    if (!this.selectedProductForDynamic) return;
    
    try {
      console.log('Loading dynamic codes for product:', this.selectedProductForDynamic);
      const response = await this._user.getDynamicCodesForProduct(this.selectedProductForDynamic) as any;
      if (response && response.dinamic_codes) {
        this.dynamicCodesForProduct = response.dinamic_codes.map((code: string) => ({
          code: code,
          name: code,
          description: `Etiqueta: ${code}`
        }));
      } else {
        this.dynamicCodesForProduct = [];
      }
      this.updateAvailableDynamicCodes();
    } catch (error) {
      console.error('Error loading dynamic codes for product:', error);
      this.dynamicCodesForProduct = [];
    }
  }

  // Enhanced modal methods
  filterAvailableCodes() {
    let codes = [...this.availableDynamicCodes];
    
    // Filter by search text
    if (this.searchDynamicCode && this.searchDynamicCode.trim()) {
      const searchTerm = this.searchDynamicCode.toLowerCase().trim();
      codes = codes.filter(code => 
        code.code.toLowerCase().includes(searchTerm) || 
        code.name.toLowerCase().includes(searchTerm)
      );
    }
    
    this.filteredAvailableCodes = codes;
  }

  selectCodeFromDropdown(code: any) {
    this.selectedDynamicCode = code.code;
    this.searchDynamicCode = code.code;
    this.showDropdown = false;
    this.errorDynamicCode = false;
  }

  clearSelectedCode() {
    this.selectedDynamicCode = '';
    this.searchDynamicCode = '';
    this.showDropdown = false;
  }

  onSearchBlur() {
    // Delay hiding dropdown to allow click events on dropdown items
    setTimeout(() => {
      this.showDropdown = false;
    }, 200);
  }

  // Remanente-Neteo Methods
  async loadRemanenteNeteoConfigs() {
    try {
      this.remainingNeteoConfigs = [];
      // Load configurations for each product
      for (const product of this.productArray) {
        try {
          const config = await this._user.getRemanenteNeteo(product.params.code);
          if (config) {
            // Backend returns data directly, not wrapped in a "data" property
            this.remainingNeteoConfigs.push({
              product_code: product.params.code,
              product_name: product.params.name,
              remanente: config.remanente || { status: false, amount: 0 },
              neteo: config.neteo || { status: false, amount: 0 }
            });
          }
        } catch (error: any) {
          // If 404, no config exists for this product, skip
          if (error.status !== 404) {
            console.error('Error loading config for product:', product.params.code, error);
          }
        }
      }
    } catch (error) {
      console.error('Error loading remanente-neteo configs:', error);
    }
  }

  async loadInsurers() {
    try {
      console.log('Loading insurers...');
      const response = await this._user.getInsurers();
      console.log('Insurers response:', response);

      if (response && response.resp) {
        this.insurers = response.resp;
        console.log('Insurers loaded successfully:', this.insurers.length, 'items');
      } else if (response && response.data) {
        this.insurers = response.data;
        console.log('Insurers loaded from data property:', this.insurers.length, 'items');
      } else if (Array.isArray(response)) {
        this.insurers = response;
        console.log('Insurers loaded as array:', this.insurers.length, 'items');
      } else {
        // Load dummy data for testing if no real data is available
        console.log('No insurers data found, loading dummy data for testing');
        this.insurers = [
          { code: 'seguros_caracas', name: 'Seguros Caracas' },
          { code: 'mapfre', name: 'Mapfre' },
          { code: 'mercantil_seguros', name: 'Mercantil Seguros' },
          { code: 'seguros_venezuela', name: 'Seguros Venezuela' }
        ];
      }
    } catch (error) {
      console.error('Error loading insurers, loading dummy data for testing:', error);
      // Load dummy data for testing when API fails
      this.insurers = [
        { code: 'seguros_caracas', name: 'Seguros Caracas' },
        { code: 'mapfre', name: 'Mapfre' },
        { code: 'mercantil_seguros', name: 'Mercantil Seguros' },
        { code: 'seguros_venezuela', name: 'Seguros Venezuela' }
      ];
    }
  }

  toggleModalRemanenteNeteo() {
    this.isModalRemanenteNeteoOpen = !this.isModalRemanenteNeteoOpen;
    if (!this.isModalRemanenteNeteoOpen) {
      this.resetRemanenteNeteoForm();
    }
  }

  async selectProductForRemanenteNeteo(event: Event) {
    const target = event.target as HTMLSelectElement;
    const productCode = target.value;
    
    this.selectedProductForRemanenteNeteo = productCode;
    this.remanenteNeteoForm.product_code = productCode;
    this.errorProductRemanenteNeteo = false;

    if (productCode && productCode !== '0') {
      try {
        const response = await this._user.getRemanenteNeteo(productCode);
        if (response) {
          // Backend returns data directly, not wrapped in a "data" property
          this.remanenteNeteoForm.remanente = response.remanente || { status: false, amount: 0 };
          this.remanenteNeteoForm.neteo = response.neteo || { status: false, amount: 0 };
          this.remanenteNeteoForm.domiciliacion = response.domiciliacion || { status: false, allowed_banks: [], allowed_types: [] };
          this.remanenteNeteoForm.fees = response.fees || { status: false };
          this.remanenteNeteoForm.display_order = response.display_order !== undefined ? response.display_order : 0;
          this.selectedAllowedBanks = this.remanenteNeteoForm?.domiciliacion?.allowed_banks || [];
          this.selectedAllowedTypes = this.remanenteNeteoForm?.domiciliacion?.allowed_types || [];
        } else {
          this.resetRemanenteNeteoFormData();
        }
      } catch (error: any) {
        if (error.status === 404) {
          this.resetRemanenteNeteoFormData();
        } else {
          console.error('Error loading product config:', error);
          alertifyjs.error('Error al cargar la configuración del producto');
        }
      }
    } else {
      this.resetRemanenteNeteoFormData();
    }
  }

  onRemanenteToggle() {
    if (!this.remanenteNeteoForm.remanente.status) {
      this.remanenteNeteoForm.remanente.amount = 0;
    }
    this.validateRemanenteAmount();
  }

  onNeteoToggle() {
    if (!this.remanenteNeteoForm.neteo.status) {
      this.remanenteNeteoForm.neteo.amount = 0;
    }
    this.validateNeteoAmount();
  }

  validateRemanenteAmount() {
    this.errorRemanenteAmount = this.remanenteNeteoForm.remanente.status && 
                                this.remanenteNeteoForm.remanente.amount <= 0;
  }

  validateNeteoAmount() {
    this.errorNeteoAmount = this.remanenteNeteoForm.neteo.status &&
                            this.remanenteNeteoForm.neteo.amount <= 0;
  }

  onInsuranceToggle() {
    if (!this.remanenteNeteoForm.insurance.is_insurance_product) {
      this.remanenteNeteoForm.insurance.insurer_code = '';
    }
    this.validateInsuranceInsurer();
  }

  validateInsuranceInsurer() {
    this.errorInsuranceInsurer = this.remanenteNeteoForm.insurance.is_insurance_product &&
                                 !this.remanenteNeteoForm.insurance.insurer_code;
  }

  onExternalRateToggle() {
    if (!this.remanenteNeteoForm.domiciliacion.use_external_rate) {
      this.remanenteNeteoForm.domiciliacion.external_rate_channel = '';
    }
    this.validateExternalRateChannel();
  }

  validateExternalRateChannel() {
    this.errorExternalRateChannel = this.remanenteNeteoForm.domiciliacion.use_external_rate &&
                                     !this.remanenteNeteoForm.domiciliacion.external_rate_channel;
  }

  onRetryLimitToggle() {
    if (!this.remanenteNeteoForm.domiciliacion.retry_limit_enabled) {
      this.remanenteNeteoForm.domiciliacion.retry_limit_days = null;
      this.remanenteNeteoForm.domiciliacion.exclude_weekends = false;
    }
    this.validateRetryLimitDays();
  }

  validateRetryLimitDays() {
    this.errorRetryLimitDays = this.remanenteNeteoForm.domiciliacion.retry_limit_enabled &&
                               (!this.remanenteNeteoForm.domiciliacion.retry_limit_days ||
                                this.remanenteNeteoForm.domiciliacion.retry_limit_days <= 0);
  }

  async saveRemanenteNeteoConfig() {
    try {
      this.isLoading = true;
      this.errorProductRemanenteNeteo = false;
      this.errorRemanenteAmount = false;
      this.errorNeteoAmount = false;
      this.errorInsuranceInsurer = false;
      this.errorExternalRateChannel = false;
      this.errorRetryLimitDays = false;

      // Validaciones
      if (!this.selectedProductForRemanenteNeteo || this.selectedProductForRemanenteNeteo === '0') {
        this.errorProductRemanenteNeteo = true;
        this.isLoading = false;
        return;
      }

      if (this.remanenteNeteoForm.remanente.status && (!this.remanenteNeteoForm.remanente.amount || this.remanenteNeteoForm.remanente.amount <= 0)) {
        this.errorRemanenteAmount = true;
        this.isLoading = false;
        return;
      }

      if (this.remanenteNeteoForm.neteo.status && (!this.remanenteNeteoForm.neteo.amount || this.remanenteNeteoForm.neteo.amount <= 0)) {
        this.errorNeteoAmount = true;
        this.isLoading = false;
        return;
      }

      if (this.remanenteNeteoForm.insurance.is_insurance_product && !this.remanenteNeteoForm.insurance.insurer_code) {
        this.errorInsuranceInsurer = true;
        this.isLoading = false;
        return;
      }

      if (this.remanenteNeteoForm.domiciliacion.use_external_rate && !this.remanenteNeteoForm.domiciliacion.external_rate_channel) {
        this.errorExternalRateChannel = true;
        this.isLoading = false;
        return;
      }

      if (this.remanenteNeteoForm.domiciliacion.retry_limit_enabled && (!this.remanenteNeteoForm.domiciliacion.retry_limit_days || this.remanenteNeteoForm.domiciliacion.retry_limit_days <= 0)) {
        this.errorRetryLimitDays = true;
        this.isLoading = false;
        return;
      }

      const configData = {
        product_code: this.selectedProductForRemanenteNeteo,
        remanente: {
          status: this.remanenteNeteoForm.remanente.status,
          amount: this.remanenteNeteoForm.remanente.status ? parseFloat(this.remanenteNeteoForm.remanente.amount) : 0
        },
        neteo: {
          status: this.remanenteNeteoForm.neteo.status,
          amount: this.remanenteNeteoForm.neteo.status ? parseFloat(this.remanenteNeteoForm.neteo.amount) : 0
        },
        insurance: {
          is_insurance_product: this.remanenteNeteoForm.insurance.is_insurance_product,
          insurer_code: this.remanenteNeteoForm.insurance.is_insurance_product ? this.remanenteNeteoForm.insurance.insurer_code : ''
        },
        domiciliacion: {
          status: this.remanenteNeteoForm.domiciliacion.status,
          allowed_banks: this.selectedAllowedBanks,
          allowed_types: this.selectedAllowedTypes,
          use_external_rate: this.remanenteNeteoForm.domiciliacion.use_external_rate || false,
          external_rate_channel: this.remanenteNeteoForm.domiciliacion.use_external_rate ? this.remanenteNeteoForm.domiciliacion.external_rate_channel : '',
          retry_limit_enabled: this.remanenteNeteoForm.domiciliacion.retry_limit_enabled || false,
          retry_limit_days: this.remanenteNeteoForm.domiciliacion.retry_limit_enabled ? parseInt(this.remanenteNeteoForm.domiciliacion.retry_limit_days) : null,
          exclude_weekends: this.remanenteNeteoForm.domiciliacion.retry_limit_enabled ? (this.remanenteNeteoForm.domiciliacion.exclude_weekends || false) : false,
          staggered_collection: this.remanenteNeteoForm.domiciliacion.staggered_collection || false,
          direct_reference_payment: this.remanenteNeteoForm.domiciliacion.direct_reference_payment || false
        },
        fees: {
          status: this.remanenteNeteoForm.fees.status,
        },
        display_order: this.remanenteNeteoForm.display_order !== undefined ? parseInt(this.remanenteNeteoForm.display_order) : 0
      };

      console.log('Datos a guardar:', configData);

      // Usar el endpoint existente que ya maneja la configuración completa
      const response = await this._user.setRemanenteNeteo(configData);
      console.log('Respuesta del servidor:', response);

      if (response) {
        alertifyjs.success('Configuración guardada exitosamente');
        await this.loadRemanenteNeteoConfigs();
        // Recargar los datos del producto actual para mostrar los valores actualizados
        if (this.selectedProductForRemanenteNeteo) {
          await this.loadRemanenteNeteoData(this.selectedProductForRemanenteNeteo);
        }
        // Don't reset the form - keep the selected product and form visible
        // this.resetRemanenteNeteoForm();
      }
    } catch (error: any) {
      console.error('Error saving remanente-neteo config:', error);
      alertifyjs.error('Error al guardar la configuración');
    } finally {
      this.isLoading = false;
    }
  }

  editRemanenteNeteoConfig(config: any) {
    this.selectedProductForRemanenteNeteo = config.product_code;
    this.remanenteNeteoForm = {
      product_code: config.product_code,
      remanente: {
        status: config.remanente?.status || false,
        amount: config.remanente?.amount || 0
      },
      neteo: {
        status: config.neteo?.status || false,
        amount: config.neteo?.amount || 0
      },
      insurance: {
        is_insurance_product: config.insurance?.is_insurance_product || false,
        insurer_code: config.insurance?.insurer_code || ''
      }
    };

    // Reset errors
    this.errorProductRemanenteNeteo = false;
    this.errorRemanenteAmount = false;
    this.errorNeteoAmount = false;
    this.errorInsuranceInsurer = false;
  }

  resetRemanenteNeteoForm() {
    this.selectedProductForRemanenteNeteo = '';
    this.resetRemanenteNeteoFormData();
    this.errorProductRemanenteNeteo = false;
    this.errorRemanenteAmount = false;
    this.errorNeteoAmount = false;
    this.errorInsuranceInsurer = false;
    this.errorExternalRateChannel = false;
  }

  private resetRemanenteNeteoFormData() {
    this.remanenteNeteoForm = {
      product_code: this.selectedProductForRemanenteNeteo,
      remanente: {
        status: false,
        amount: 0
      },
      neteo: {
        status: false,
        amount: 0
      },
      insurance: {
        is_insurance_product: false,
        insurer_code: ''
      },
      domiciliacion: {
        status: false,
        allowed_banks: [],
        allowed_types: [],
        use_external_rate: false,
        external_rate_channel: '',
        retry_limit_enabled: false,
        retry_limit_days: null,
        exclude_weekends: false,
        staggered_collection: false,
        direct_reference_payment: false
      },
      fees: {
        status: false
      },
      display_order: 0
    };
  }

  // Domiciliación Methods
  onDomiciliacionToggle() {
    // No additional validation needed for domiciliacion toggle
  }

  // Fees Methods
  onFeesToggle() {
    // No additional validation needed for fees toggle
  }

  getConfigForProduct(productCode: string) {
    return this.remainingNeteoConfigs.find(config => config.product_code === productCode);
  }

  // 🆕 ========================================
  // MÉTODOS PARA T&C DE DOMICILIACIÓN
  // ========================================

  /**
   * Cargar bancos que tienen T&C configurados para el producto actual
   */
  async loadBanksWithTermsConfigured() {
    if (!this.selectedProductType?.params?.code) return;

    this.banksWithTermsConfigured.clear();

    try {
      // Verificar cada banco si tiene T&C
      for (const bank of this.banksList) {
        try {
          const response: any = await this._user.getActiveDomiciliationTermsByBank(
            this.selectedProductType.params.code,
            bank.code
          );
          
          if (response?.success && response?.terms) {
            this.banksWithTermsConfigured.add(bank.code);
          }
        } catch (error) {
          // Si da 404, el banco no tiene T&C configurados
          console.log(`Banco ${bank.code} no tiene T&C configurados`);
        }
      }
    } catch (error) {
      console.error('Error cargando bancos con T&C:', error);
    }
  }

  /**
   * Verificar si un banco tiene T&C configurados
   */
  bankHasTermsConfigured(bankCode: string): boolean {
    return this.banksWithTermsConfigured.has(bankCode);
  }

  /**
   * Abrir modal para crear/editar T&C de domiciliación por banco
   */
  async openTermsConditionsModal(productCode: string, bankCode: string) {
    this.isModalTermsConditionsOpen = true;
    this.termsConditionsForm.product_type = productCode;
    this.termsConditionsForm.bank_code = bankCode;
    this.isLoadingTerms = true;
    this.showTermsHistory = false;

    const bankName = this.bankNameByCode(bankCode);
    const productName = this.getProductName(productCode);

    try {
      // Intentar cargar T&C activo para este banco + producto
      const response: any = await this._user.getActiveDomiciliationTermsByBank(productCode, bankCode);
      
      if (response?.success && response?.terms) {
        // Existe T&C activo - Modo edición
        this.isEditingTerms = true;
        this.currentTermsVersion = response.terms;
        this.termsConditionsForm.name = response.terms.name;
        this.termsConditionsForm.details = response.terms.details;
        console.log(`✅ T&C encontrados para ${bankName} + ${productName}`);
      } else {
        // No existe T&C - Modo creación
        this.isEditingTerms = false;
        this.currentTermsVersion = null;
        this.termsConditionsForm.name = `T&C de Domiciliación - ${bankName} - ${productName}`;
        this.termsConditionsForm.details = '';
        console.log(`ℹ️ No hay T&C para ${bankName} + ${productName}, modo creación`);
      }
    } catch (error) {
      console.error('Error cargando T&C:', error);
      // Modo creación por defecto
      this.isEditingTerms = false;
      this.currentTermsVersion = null;
      this.termsConditionsForm.name = `T&C de Domiciliación - ${bankName} - ${productName}`;
      this.termsConditionsForm.details = '';
    } finally {
      this.isLoadingTerms = false;
    }
  }

  /**
   * Cerrar modal de T&C
   */
  closeTermsConditionsModal() {
    this.isModalTermsConditionsOpen = false;
    this.resetTermsConditionsForm();
  }

  /**
   * Guardar T&C (crear o editar)
   */
  async saveTermsConditions() {
    // Validaciones
    this.errorTermsName = !this.termsConditionsForm.name || this.termsConditionsForm.name.trim() === '';
    this.errorTermsDetails = !this.termsConditionsForm.details || this.termsConditionsForm.details.trim() === '';

    if (this.errorTermsName || this.errorTermsDetails) {
      alertifyjs.error('Por favor complete todos los campos requeridos');
      return;
    }

    this.isLoadingTerms = true;

    try {
      let response: any;

      if (this.isEditingTerms) {
        // Editar (crea nueva versión)
        response = await this._user.editDomiciliationTerms({
          product_type: this.termsConditionsForm.product_type,
          bank_code: this.termsConditionsForm.bank_code,
          name: this.termsConditionsForm.name,
          details: this.termsConditionsForm.details
        });

        if (response?.success) {
          alertifyjs.success(`T&C actualizado exitosamente - Versión ${response.terms.version}`);
        }
      } else {
        // Crear nuevo
        response = await this._user.createDomiciliationTerms({
          product_type: this.termsConditionsForm.product_type,
          bank_code: this.termsConditionsForm.bank_code,
          name: this.termsConditionsForm.name,
          details: this.termsConditionsForm.details
        });

        if (response?.success) {
          alertifyjs.success('T&C creado exitosamente');
        }
      }

      // Recargar la lista de bancos con T&C configurados
      await this.loadBanksWithTermsConfigured();
      
      this.closeTermsConditionsModal();
      
    } catch (error: any) {
      console.error('Error guardando T&C:', error);
      const errorMessage = error?.error?.message || error?.message || 'Error al guardar T&C';
      alertifyjs.error(errorMessage);
    } finally {
      this.isLoadingTerms = false;
    }
  }

  /**
   * Ver historial de versiones de T&C
   */
  async viewTermsHistory() {
    this.isLoadingTerms = true;
    this.showTermsHistory = true;

    try {
      const response: any = await this._user.getTermsHistoryByBank(
        this.termsConditionsForm.product_type,
        this.termsConditionsForm.bank_code
      );
      
      if (response?.success) {
        this.termsHistory = response.history || [];
      } else {
        this.termsHistory = [];
      }
    } catch (error) {
      console.error('Error cargando historial de T&C:', error);
      alertifyjs.error('Error al cargar historial de T&C');
      this.termsHistory = [];
    } finally {
      this.isLoadingTerms = false;
    }
  }

  /**
   * Ocultar historial de versiones
   */
  hideTermsHistory() {
    this.showTermsHistory = false;
  }

  /**
   * Alternar modo de vista previa en el modal
   */
  togglePreviewMode() {
    this.showPreview = !this.showPreview;
  }

  /**
   * Abrir modal de vista previa de T&C (desde la lista de bancos)
   */
  async previewTermsConditions(productCode: string, bankCode: string) {
    try {
      const response: any = await this._user.getActiveDomiciliationTermsByBank(productCode, bankCode);
      
      if (response?.success && response?.terms) {
        const terms = response.terms;
        
        // Crear un modal de vista previa
        const modalContent = `
          <div style="max-width: 800px; max-height: 600px; overflow-y: auto;">
            <div style="border-bottom: 2px solid #2563eb; padding-bottom: 12px; margin-bottom: 16px;">
              <h3 style="color: #2563eb; margin: 0; font-size: 18px; font-weight: 600;">
                <i class="fas fa-file-contract"></i> ${terms.name}
              </h3>
              <p style="color: #6b7280; font-size: 14px; margin: 8px 0 0 0;">
                <strong>Producto:</strong> ${productCode} | <strong>Banco:</strong> ${bankCode}
              </p>
              <p style="color: #6b7280; font-size: 12px; margin: 4px 0 0 0;">
                <strong>Versión:</strong> ${terms.version} | 
                <strong>Fecha:</strong> ${new Date(terms.date).toLocaleDateString('es-ES')}
              </p>
            </div>
            <div style="padding: 16px; background: #f9fafb; border-radius: 8px;">
              ${terms.details}
            </div>
          </div>
        `;
        
        alertifyjs.alert('Vista Previa de Términos y Condiciones', modalContent);
      } else {
        alertifyjs.warning('No se encontraron T&C para este banco y producto');
      }
    } catch (error) {
      console.error('Error cargando T&C para vista previa:', error);
      alertifyjs.error('Error al cargar la vista previa');
    }
  }

  /**
   * Ver preview de una versión específica del historial
   */
  previewTermsVersion(version: any) {
    if (!version) {
      alertifyjs.error('No se puede mostrar la vista previa');
      return;
    }

    // Crear un modal de vista previa con la información de la versión
    const modalContent = `
      <div style="max-width: 900px; max-height: 700px; overflow-y: auto;">
        <div style="border-bottom: 2px solid #2563eb; padding-bottom: 12px; margin-bottom: 16px;">
          <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 8px;">
            <span style="background: ${version.status === 'ACTIVE' ? '#dcfce7' : '#f3f4f6'}; 
                         color: ${version.status === 'ACTIVE' ? '#166534' : '#4b5563'}; 
                         padding: 4px 12px; border-radius: 9999px; font-size: 12px; font-weight: 600;">
              <i class="fas ${version.status === 'ACTIVE' ? 'fa-check-circle' : 'fa-archive'}"></i>
              ${version.status === 'ACTIVE' ? 'Activa' : 'Inactiva'}
            </span>
            <span style="color: #2563eb; font-size: 16px; font-weight: 700;">
              Versión ${version.version}
            </span>
          </div>
          
          <h3 style="color: #1f2937; margin: 0 0 12px 0; font-size: 18px; font-weight: 600;">
            <i class="fas fa-file-contract" style="color: #2563eb;"></i> ${version.name}
          </h3>
          
          <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 8px; font-size: 13px; color: #6b7280;">
            <div>
              <i class="fas fa-calendar" style="color: #2563eb;"></i>
              <strong>Creada:</strong> ${this.formatDate(version.createdAt)}
            </div>
            ${version.edited_at ? `
              <div>
                <i class="fas fa-edit" style="color: #2563eb;"></i>
                <strong>Editada:</strong> ${this.formatDate(version.edited_at)}
              </div>
            ` : ''}
            ${version.created_by ? `
              <div>
                <i class="fas fa-user" style="color: #2563eb;"></i>
                <strong>Creado por:</strong> ${version.created_by.name || version.created_by.username}
              </div>
            ` : ''}
            ${version.edited_by ? `
              <div>
                <i class="fas fa-user-edit" style="color: #2563eb;"></i>
                <strong>Editado por:</strong> ${version.edited_by.name || version.edited_by.username}
              </div>
            ` : ''}
            ${version.end_date ? `
              <div style="grid-column: 1 / -1;">
                <i class="fas fa-clock" style="color: #6b7280;"></i>
                <strong>Fin de vigencia:</strong> ${this.formatDate(version.end_date)}
              </div>
            ` : ''}
          </div>
        </div>
        
        <div style="background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 8px; padding: 20px;">
          <h4 style="color: #374151; margin: 0 0 12px 0; font-size: 14px; font-weight: 600; border-bottom: 1px solid #d1d5db; padding-bottom: 8px;">
            <i class="fas fa-file-alt"></i> Contenido de los Términos y Condiciones
          </h4>
          <div style="background: white; padding: 16px; border-radius: 6px; line-height: 1.6;">
            ${version.details || '<p style="color: #9ca3af; font-style: italic;">Sin contenido disponible</p>'}
          </div>
        </div>
        
        ${version.status === 'INACTIVE' && version.end_date ? `
          <div style="margin-top: 16px; padding: 12px; background: #fef3c7; border-left: 4px solid #f59e0b; border-radius: 4px;">
            <p style="margin: 0; color: #92400e; font-size: 13px;">
              <i class="fas fa-info-circle"></i>
              <strong>Nota:</strong> Esta versión fue desactivada el ${this.formatDate(version.end_date)} y ya no está en uso.
            </p>
          </div>
        ` : ''}
      </div>
    `;
    
    alertifyjs.alert(
      `<i class="fas fa-eye"></i> Vista Previa - Versión ${version.version}`, 
      modalContent
    ).set({
      closable: true,
      maximizable: false,
      resizable: false,
      padding: false
    });
  }

  /**
   * Verificar si un producto tiene T&C configurados
   */
  async hasTermsConditions(productCode: string): Promise<boolean> {
    try {
      const response: any = await this._user.checkDomiciliationTermsExist(productCode);
      return response?.success && response?.has_terms === true;
    } catch (error) {
      console.error('Error verificando T&C:', error);
      return false;
    }
  }

  /**
   * Resetear formulario de T&C
   */
  resetTermsConditionsForm() {
    this.termsConditionsForm = {
      product_type: '',
      bank_code: '',
      name: '',
      details: ''
    };
    this.currentTermsVersion = null;
    this.termsHistory = [];
    this.showTermsHistory = false;
    this.errorTermsName = false;
    this.errorTermsDetails = false;
    this.isLoadingTerms = false;
    this.isEditingTerms = false;
    this.showPreview = false; // Resetear vista previa
  }

  /**
   * Obtener nombre del producto
   */
  getProductName(productCode: string): string {
    const product = this.productArray.find(p => p.code === productCode);
    return product ? product.name : productCode;
  }

  /**
   * Formatear fecha para mostrar
   */
  formatDate(date: string | Date): string {
    if (!date) return '-';
    const d = new Date(date);
    return d.toLocaleDateString('es-ES', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }
}
